module.exports = __webpack_public_path__ + "static/media/german-months-seasons.fce1cf71.jpg";